var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColdWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM7 12.49C7 10.664 8.4685 8.5025 11.4 6C14.3315 8.5025 15.8 10.664 15.8 12.49C15.8 15.229 13.71 17 11.4 17C9.09 17 7 15.229 7 12.49ZM9.5135 12.941C9.475 12.743 9.31 12.6 9.1065 12.6C9.04676 12.6 8.98774 12.613 8.93352 12.6381C8.8793 12.6632 8.83118 12.6997 8.79247 12.7452C8.75377 12.7907 8.72541 12.8441 8.70936 12.9017C8.69331 12.9592 8.68994 13.0195 8.6995 13.0785C9.013 14.745 10.3825 15.416 11.554 15.3445C11.774 15.3335 11.95 15.152 11.95 14.932C11.95 14.6955 11.752 14.5085 11.5155 14.5195C10.7675 14.58 9.739 14.162 9.5135 12.941Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdWater);
export default __webpack_public_path__ + "static/media/coldWater.bfc23382f8d8edfae6033021b847a546.svg";
export { ForwardRef as ReactComponent };